<template>
    <div v-loading="isLoading" class="markup-tables">
        <a-row>
            <a-col v-for="rob in tableData" :key="rob.id">
                <a-card hoverable style="width: 200px; margin: 5px">
                    <template #cover>
                        <img
                            v-if="rob.Photo == ''"
                            style="height: 200px; object-fit: contain"
                            alt=""
                            src="@/static/images/robot06.png"
                        />
                        <img
                            v-else
                            style="height: 200px; object-fit: contain"
                            alt=""
                            :src="rob.Photo"
                        />
                    </template>
                    <template #actions>
                        <play-circle-filled
                            title="运行流程"
                            style="color: green; font-size: 26px"
                            v-if="rob.Status === '空闲中'"
                            @click="playProcess(rob.id)"
                        />
                        <close-circle-filled
                            style="color: gray; font-size: 26px"
                            v-else
                        />
                        <history-outlined
                            title="执行记录"
                            style="font-size: 26px"
                            @click="firstFindJob(rob.ProcessName, rob.Pc_No)"
                        />
                        <setting-outlined
                            title="修改机器人信息"
                            style="font-size: 26px"
                            @click="showSetting(rob)"
                        />
                    </template>

                    <div class="hcqFont" :title="rob.Alias">
                        {{ rob.Alias }}
                    </div>
                    <div style="color: gray">{{ rob.ProcessName }}</div>
                    <div
                        :style="{
                            color: rob.Status === '空闲中' ? 'green' : 'blue',
                        }"
                    >
                        状态：{{ rob.Status }}
                    </div>
                    <div>
                        机器人：{{ rob.Abbr
                        }}<span
                            :class="
                                rob.IsTest
                                    ? rob.IsTest === '测试'
                                        ? 'badge badge-test'
                                        : 'badge badge-prod'
                                    : ''
                            "
                        >
                            {{ rob.IsTest }}</span
                        >
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>

    <!-- <div style="margin-top: 10px; flex: auto">
    <va-button class="mr-2 mb-2" size="small" flat @click="showAsset">
      {{ $t("dashboard.MyTabs.robot.btnAsset") }}
    </va-button>
    <va-button v-if="false" class="mr-2 mb-2" size="small" flat disabled="true">
      {{ $t("dashboard.MyTabs.robot.btnRemote") }}
    </va-button>
  </div> -->
    <vxe-modal
        title="执行日志"
        v-model="isShowJobHis"
        width="840"
        maskClosable
        show-zoom
        resize
    >
        <template #default>
            <div>
                <div>
                    <vxe-form>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button @click="findDataJob"
                                    >刷新</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableDataJob"
                        :cell-style="cellStyle"
                        height="300"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                        ref="xTable2"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="日志" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search-plus"
                                    @click="viewLog(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="StateName"
                            title="状态"
                            width="100"
                            align="center"
                        ></vxe-column>
                        <vxe-column
                            field="CreatorUserId"
                            title="邮箱"
                            width="160"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="ProcessKey"
                            title="流程ID"
                            width="130"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程名称"
                            width="220"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器简称"
                            width="110"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="StartTime"
                            title="开始时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="EndTime"
                            title="结束时间"
                            width="160"
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="机器人"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="EnvironmentName"
                            title="部署环境"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="Key"
                            title="Key"
                            width="160"
                            :visible="false"
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal
        title="日志明细"
        v-model="logForm.iShow"
        width="900"
        maskClosable
        resize
        show-zoom
    >
        <template #default>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="logForm.dtLog"
                    ref="xTableUser"
                    height="300"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="id"
                        title="序号"
                        width="60"
                    ></vxe-column>
                    <vxe-column title="状态" width="60">
                        <template #default="{ row }">
                            <span>{{
                                row.Level == "Info" ? "信息" : "错误"
                            }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column
                        field="ProcessName"
                        title="流程ID"
                        width="140"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="RobotName"
                        title="机器人"
                        width="160"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="Message"
                        title="信息"
                        width="400"
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="TimeStamp"
                        title="操作时间"
                        width="160"
                    ></vxe-column>
                </vxe-table>
            </div>
        </template>
    </vxe-modal>
    <!-- 编辑机器人-->
    <vxe-modal
        v-model="formInput.isShow"
        title="修改机器人信息"
        width="840"
        height="600"
        @close="findData"
        show-zoom
        resize
        remember
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                title-align="right"
                ref="rFormTableau"
                height="100%"
                title-width="60"
            >
                <vxe-form-item
                    title="机器人信息"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-address-card-o' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="流程ID"
                    field="applyMan"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.ProcessName"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="流程名称"
                    field="jobNumber"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.ProcessNo"
                            disabled
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="别名"
                    field="Alias"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.Alias"
                            maxlength="50"
                            placeholder="请输入别名"
                            clearable
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="机器人头像"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-paperclip' }"
                ></vxe-form-item>
                <vxe-form-item title="" align="center" span="24">
                    <template #default>
                        <div>
                            <div>
                                <vxe-button @click="setDefaultPhoto"
                                    >默认头像</vxe-button
                                >
                                <vxe-button
                                    status="primary"
                                    @click="insertEvent(false)"
                                    >选择文件
                                </vxe-button>
                                <span class="photo-dec"
                                    >支持jpg、jpeg、png、gif格式的图片</span
                                >
                            </div>
                            <div style="padding-top: 10px">
                                <img
                                    v-if="formInput.formData.Photo === ''"
                                    style="
                                        width: 150px;
                                        height: 150px;
                                        object-fit: contain;
                                    "
                                    alt=""
                                    src="@/static/images/robot06.png"
                                />
                                <img
                                    v-else
                                    :src="formInput.formData.Photo"
                                    alt=""
                                    style="
                                        width: 150px;
                                        height: 150px;
                                        object-fit: contain;
                                    "
                                />
                            </div>
                        </div>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    align="center"
                    span="24"
                    style="position: absolute; bottom: 0"
                >
                    <template #default>
                        <vxe-button
                            @click="save"
                            icon="fa fa-save"
                            status="success"
                            style="margin-top: 50px"
                        >
                            保存
                        </vxe-button>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
    </vxe-modal>
</template>

<script>
import { reactive, ref } from "vue";
import { VXETable, VxeTableInstance, VxeTablePropTypes } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import {
    SettingOutlined,
    PlayCircleFilled,
    HistoryOutlined,
    CloseCircleFilled,
} from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

export default {
    name: "MyRobotTable",
    components: {
        SettingOutlined,
        PlayCircleFilled,
        HistoryOutlined,
        CloseCircleFilled,
    },
    data() {
        const formInput = reactive({
            isShow: false,
            formData: {
                id: "",
                ProcessName: "",
                ProcessNo: "",
                Alias: "",
                Photo: "",
            },
            formRules: {},
        });
        const logForm = reactive({
            dtLog: [],
            iShow: false, //显示更新包
            pager: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
        });
        const cellStyle = ({ row, column }) => {
            if (column.field === "StateName") {
                if (row.StateName === "运行完成") {
                    return {
                        color: "#008000",
                    };
                } else if (row.StateName === "运行异常") {
                    return {
                        color: "#FF0000",
                    };
                } else {
                    return {
                        color: "#0000FF",
                    };
                }
            }
        };
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: {
                processKey: "",
                machineName: "",
            },
        });
        return {
            tableData: null,
            tableDataJob: null,
            isLoading: true,
            timer: null, //定时器名称
            cellStyle,
            tablePager,
            isShowJobHis: false,
            logForm,
            formInput,
            oneFileName: "",
            oneFile: {},
        };
    },
    methods: {
        showSetting(row) {
            this.formInput.isShow = true;
            this.formInput.formData.Photo = row.Photo;
            this.formInput.formData.id = row.id;
            this.formInput.formData.ProcessName = row.ProcessName;
            this.formInput.formData.Alias = row.Alias;
            this.formInput.formData.ProcessNo = row.ProcessNo;
        },
        //保存修改机器人信息
        async save() {
            const params = this.formInput.formData;

            this.$api.jobManageAPI
                .saveRobotAlias(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "保存成功",
                        status: "success",
                    });
                    this.findData();
                    this.formInput.isShow = false;
                })
                .catch((error) => {
                    VXETable.modal.message({ content: error, status: "error" });
                    console.log(error);
                });
        },
        findData() {
            const params = {
                uid: this.getUserId,
                email: this.getUserEmail,
                currentPage: 1,
                pageSize: 999,
                searchKey: ["1"], //是否是首页查询 1 是 0 否
            };
            message.loading({
                content: "Loading...",
                key: "updatable",
                duration: 0,
            });
            this.$api.jobManageAPI
                .getProcessTakeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.isLoading = false;
                    // 关闭加载
                    message.destroy("updatable");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        firstFindJob(processKey, machineName) {
            this.tablePager.searchKey.machineName = machineName;
            this.tablePager.searchKey.processKey = processKey;
            this.findDataJob();
        },
        findDataJob() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.tablePager.searchKey.processKey,
                    "",
                    this.tablePager.searchKey.machineName,
                    this.$store.state.email,
                ],
            };
            this.$api.jobManageAPI
                .getJobsList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableDataJob = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.isShowJobHis = true;
                    // debugger;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        viewLog(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: ["", "", "", "", row.Key],
            };
            this.$api.jobManageAPI
                .getLogsList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.logForm.dtLog = res.data.Data.dataTable;
                    this.logForm.iShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findDataJob();
        },
        //启动一个流程
        async startProcess(row) {
            const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
            if (type === "confirm") {
                const params = {
                    uid: this.getUserId,
                    email: this.getUserEmail,
                    actionType: "1",
                    actionKey: [row.id, this.getUserName],
                };
                this.$api.jobManageAPI
                    .startProcess(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        // console.log(res.data.Data);
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        async playProcess(pId) {
            const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
            if (type === "confirm") {
                const params = {
                    uid: this.getUserId,
                    email: this.getUserEmail,
                    actionType: "1",
                    actionKey: [pId, this.getUserName],
                };
                this.$api.jobManageAPI
                    .startProcess(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        // console.log(res.data.Data);
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //选择本地文件上传
        async insertEvent() {
            const { files } = await VXETable.readFile(false);

            Array.from(files).map((file) => {
                this.oneFileName = file.name;
                this.oneFile = file;
                this.updatePortrait(file);
                console.log(file);
            });
        },
        //上传头像
        updatePortrait(fileParam) {
            const fData = new FormData();
            // if(this.oneFile == null){
            //   VXETable.modal.message({ content: '请上传图片！', status: 'warning' })
            //   return false;
            // }

            fData.append("id", this.formInput.formData.id); //0 传0或不传
            fData.append("fileName", this.formInput.formData.Photo); //0 传0或不传
            fData.append("file", fileParam); //版块ID
            this.$api.jobManageAPI
                .updateRobotPhoto(fData)
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData.Photo = res.data.Data;
                    console.log(res);
                    VXETable.modal.message({
                        content: "上传头像成功",
                        status: "success",
                    });

                    // this.$router.push({name: 'single-login'});
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setDefaultPhoto() {
            this.formInput.formData.Photo = "";
        },
        showAsset() {
            this.$router.push({ name: "assetList" });
        },
        getStatus(row) {
            if (row.Status === "空闲中") {
                return "success";
            }
        },
        getDisable(row) {
            if (row.Status === "空闲中") {
                return false;
            } else {
                return true;
            }
        },
        setTimer() {
            this.timer = setInterval(() => {
                window.setTimeout(this.findData, 0);
            }, 1000 * 10);
        },
        clearTimer() {
            window.clearInterval(this.timer);
            this.timer = null;
        },
    },
    mounted() {
        this.findData();
        this.setTimer();
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserId() {
            return this.$store.state.userID;
        },
    },
    beforeUnmount() {
        this.clearTimer();
    },
};
</script>

<style lang="scss">
.markup-tables {
    .table-wrapper {
        overflow: auto;
    }

    .va-table {
        width: 100%;
    }

    .my-primary {
        color: #3196ff;
    }

    .my-success {
        color: #67c23a;
    }
}

.photo-dec {
    font-size: 12px;
    color: #a1a1a1;
    vertical-align: middle;
    margin-left: 10px;
}

.hcqFont {
    // background-color: #417CA9;
    color: rgb(21, 78, 193);
    font-family: "", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: bold;
}
.badge {
    display: inline-block;
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 500;
    line-height: 1.2;
    user-select: none;
}

/* 正式 = 绿色 */
.badge-prod {
    background-color: #e8f5e9; /* very light green */
    color: #2e7d32; /* green text */
    border: 1px solid #c8e6c9;
}

/* 测试 = 橙色 */
.badge-test {
    background-color: #fff3e0; /* very light orange */
    color: #e65100; /* orange text */
    border: 1px solid #ffe0b2;
}
</style>
